/**
 * Experimental Landing Page Translations
 * =========================
 */

import { Translations } from '../shared/i18n';

export const landingTranslations: Translations = {
  en: {
    landingSeoTitle: "KontoMatch | AI Invoice Processing & Bank Reconciliation",
    landingSeoDesc:
      "KontoMatch automatically reads your invoices with OCR and matches them to your bank statements. AI-powered bookkeeping for freelancers and small businesses. Free plan available.",
    howSeoTitle: "KontoMatch | How It Works",
    howSeoDesc: "Three simple steps: upload your expenses and bank statements, let AI match everything automatically. See how KontoMatch works.",
    securitySeoTitle: "KontoMatch | Security",
    securitySeoDesc: "KontoMatch stores your data on EU-based servers with industry-standard encryption. GDPR compliant. Your invoices and bank statements are never shared.",
    pricingSeoTitle: "KontoMatch | Pricing",
    pricingSeoDesc: "KontoMatch offers a free plan and paid plans from €3/month. AI invoice processing and bank reconciliation for freelancers and small businesses.",
    navHowItWorks: "How it works",
    navFeatures: "Features",
    navPricing: "Pricing",
    navSecurity: "Security",
    navAbout: "About Us",
    navSignIn: "Sign in",
    navStartFree: "Start free",

    heroTitle1: "Stop losing weekends",
    heroTitle2: "to bookkeeping.",
    heroSub:
      "You upload. We match everything. Expenses, revenues, bank statements matched and reconciled in seconds.",
    heroBtn: "Get started free",
    heroNote: "No credit card required. Free to start.",
    heroTrust1: "EU servers only",
    heroTrust2: "GDPR compliant",
    heroTrust3: "Data never used for training",

    cardReceipt: "Receipt / Beleg",
    cardBank: "Bank Statement",
    cardMatched: "Matched",
    cardAutoMatched: "Auto matched",
    cardMatchDesc: "Mediamarkt · 14.02.2025 · €349,00",
    cardTag1: "Tax relevant",
    cardTag2: "Office supplies",
    cardTag3: "DATEV-ready",

    proofTime: "From upload to export",
    proofRate: "Auto match rate",
    proofSaved: "Saved per month",
    proofStart: "to start",

    howTitle: "Three steps. Zero chaos.",
    howSub:
      "No training required. If you can drag and drop a file, you can use KontoMatch.",
    how1Title: "Upload your expenses",
    how1Desc:
      "Drop in invoices, receipts, and bills in any format, PDF, JPG, PNG, HEIC. Documents from most countries are handled natively.",
    how2Title: "Upload your bank statement",
    how2Desc:
      "Import your monthly statement as PDF or CSV export. All major banks supported.",
    how3Title: "AI matches everything",
    how3Desc:
      "KontoMatch reads every document, extracts amounts and dates, and matches each Beleg to the corresponding transaction.",

    featTitle: "Everything you need.",
    featSub:
      "No manual entry. No spreadsheets. Just a complete, export-ready file.",
    feat1Title: "AI document reading",
    feat1Desc:
      "Reads scanned receipts, email invoices, and handwritten notes. No manual entry.",
    feat2Title: "Smart bank matching",
    feat2Desc:
      "Every document matched automatically. Discrepancies and missing receipts surface right away.",
    feat3Title: "Auto categorization",
    feat3Desc:
      "Expenses sorted by category automatically, travel, software, services, and more.",
    feat4Title: "DATEV-ready export",
    feat4Desc:
      "XLSX and export-compatible CSV your accountant can import directly.",
    feat5Title: "Built for global teams",
    feat5Desc:
      "Multi-currency matching at the exact exchange rate at time of spend. VAT/GST and major banks included.",
    feat6Title: "Monthly overview",
    feat6Desc:
      "Clean month-by-month income and expense view across all reconciliations",

    secTitle: "Secured like a Swiss bank.",
    secSub: "Your documents are your business. Nobody else's.",
    sec1Title: "EU data hosting",
    sec1Desc: "All documents and data stored on German servers. AI processing secured with GDPR-compliant safeguards.",
    sec2Title: "Bank-grade protection",
    sec2Desc: "Your documents are protected with the same encryption standards trusted by financial institutions.",
    sec3Title: "Your data stays yours",
    sec3Desc: "Never sold. Never used to train our AI. Processed only to deliver your results.",
    sec4Title: "Full deletion on demand",
    sec4Desc: "Export or permanently delete all your data at any time.",

    prTitle: "Pricing",
    prH2: "Simple Honest Pricing",
    prSub: "Start free, scale only when you need to",

    prFreeTitle: "Free",
    prFreeDesc: "For anyone who wants to try it properly. No time limit, no catch.",
    prFreePeriod: "forever",
    prFreeF1: "Up to 20 documents",
    prFreeF2: "AI matching & categorisation",
    prFreeF3: "XLSX export",
    prFreeF4: "DATEV export",
    prFreeF5: "Priority processing",
    prFreeF6: "Multi-month history",
    prFreeF7: "",
    prFreeBtn: "Start free",

    prPayTitle: "Pay as you go",
    prPayDesc: "For freelancers who reconcile quarterly. Pay only when you use it.",
    prPayPeriod: "per matching run",
    prPayF1: "Up to 50 documents",
    prPayF2: "AI matching & categorisation",
    prPayF3: "XLSX + DATEV export",
    prPayF4: "Missing document flagging",
    prPayF5: "Full audit trail",
    prPayF6: "Priority processing",
    prPayF7: "10 years data retention",
    prPayBtn: "Get started",

    prProBadge: "Most Popular",
    prStarTitle: "Starter",
    prStarDesc: "For founders and freelancers doing monthly bookkeeping. Predictable cost.",
    prStarPeriod: "/month",
    prStarF1: "Up to 100 documents per month",
    prStarF2: "AI matching & categorisation",
    prStarF3: "XLSX + DATEV export",
    prStarF4: "Missing document flagging",
    prStarF5: "Full audit trail",
    prStarF6: "Priority processing",
    prStarF7: "10 years data retention",
    prStarBtn: "Get started",

    prProTitle: "Pro",
    prProDesc: "For active businesses or anyone who reconciles weekly.",
    prProF1: "Up to 500 documents per month",
    prProF2: "AI matching & categorisation",
    prProF3: "XLSX + DATEV export",
    prProF4: "Full audit trail",
    prProF5: "Priority processing",
    prProF6: "10 years data retention",
    prProF7: "Early access to new features",

    ctaTitle1: "Stop losing weekends",
    ctaTitle2: "to bookkeeping.",
    ctaSub:
      "Join founders and freelancers around the world who already saved 10+ hours this month.",
    ctaBtn: "Start for free",
    ctaT1: "No credit card required",
    ctaT2: "Free to start",
    ctaT3: "Live in minutes",

    footBrand: "Built by operators. For operators.",
    footProduct: "Product",
    footLegal: "Legal",
    footLang: "Language",
    footTerms: "Terms of Service",
    footPrivacy: "Privacy Policy",
    footImprint: "Imprint",
    footGDPR: "GDPR",

    heroAnimBankStatement: "Bank Statement",
    heroAnim1Transaction: "1 Transaction",
    heroAnim2Transactions: "2 Transactions",
    heroAnim3Transactions: "3 Transactions",
    heroAnim4Transactions: "4 Transactions",
    heroAnimExpensesRevenues: "Expenses & Revenues",
    heroAnim1Receipt: "1 Receipt",
    heroAnim2Receipts: "2 Receipts",
    heroAnim3Receipts: "3 Receipts",
    heroAnim4Receipts: "4 Receipts",
    heroAnimDropCsv: "Drop CSV files here",
    heroAnimDropReceipts: "Drop receipts here",
    heroAnimMatchedAuto: "3 transactions matched automatically",
    heroAnimNeedsReview: "1 needs review",
    stepAnimDropOrClick: "Drop or click",
    stepAnimRecentDocs: "RECENT DOCUMENTS",
    stepAnimNoDocs: "No documents yet",
    stepAnimUploadExpenses: "Upload Expenses",
    stepAnimUploadRevenue: "Upload Revenues",
    stepAnimStatementTitle: "Statement · Jan 2025",
    stepAnimDate: "Date",
    stepAnimPurpose: "Description",
    stepAnimAmount: "Amount",
    stepAnim4Transactions: "4 transactions",
    stepAnim4Receipts: "4 receipts",

    stepAnimExpFile1: "utilities_oct.csv",
    stepAnimExpAmt1: "$1,240",
    stepAnimExpFile2: "rent_invoice.pdf",
    stepAnimExpAmt2: "$3,500",
    stepAnimExpFile3: "supplies_q3.xlsx",
    stepAnimExpAmt3: "$870",
    stepAnimRevFile1: "statement_jan.pdf",
    stepAnimRevAmt1: "$2,400",
    stepAnimRevFile2: "sales_q3.csv",
    stepAnimRevAmt2: "$18,200",
    stepAnimRevFile3: "income_oct.xlsx",
    stepAnimRevAmt3: "$9,750",
    stepAnimExpIcon1: "utilities.csv",
    stepAnimExpIcon2: "rent.pdf",
    stepAnimExpIcon3: "supplies.xlsx",
    stepAnimRevIcon1: "stmt_jan.pdf",
    stepAnimRevIcon2: "sales_q3.csv",
    stepAnimRevIcon3: "income.xlsx",
    faqPageTitle: 'KontoMatch | FAQ',
    faqPageDescription: 'Answers to the most common questions about invoice processing, bank reconciliation, OCR accuracy, and data security on KontoMatch.',
    faqH2: 'Frequently Asked Questions',
    faqSub: 'Everything you need to know about KontoMatch.',
    faqCatGeneral: 'General',
    faqCatOCR: 'OCR & Accuracy',
    faqCatMatch: 'Reconciliation & Matching',
    faqCatSec: 'Security & Privacy',
    faqQ1: 'What exactly does KontoMatch do?',
    faqA1: 'KontoMatch is an AI-powered platform designed to automate your expense management. You can upload your invoices (in PDF or image format), and our system will automatically extract key details like the vendor, date, amount, and tax. It also categorizes these expenses and allows you to export them as organized Excel reports.',
    faqQ2: 'Do I need a credit card to get started?',
    faqA2: 'No. You can sign up and start using our Free Plan immediately without providing any credit card information. We believe you should experience the value of our Optical Character Recognition (OCR) technology before deciding to upgrade.',
    faqQ3: 'Which file formats are supported for uploads?',
    faqA3: 'We support common digital formats including PDF, JPEG, and PNG. Whether you have a digital receipt or a photo of a physical invoice, our AI is capable of processing it.',
    faqQ4: 'How accurate is the OCR technology?',
    faqA4: 'Our proprietary AI-powered Optical Character Recognition (OCR) engine is optimized for high accuracy, achieving over 90% accuracy in data extraction. In internal benchmarks, it consistently outperforms generic solutions like Google Document AI, Gemini, and ChatGPT, especially for localized invoice formats.',
    faqQ5: 'Does the platform support multiple invoices in a single file?',
    faqA5: 'Yes! Our system includes Multi-Invoice Detection, meaning it can identify and separate different invoices even if they are uploaded within the same document or batch.',
    faqQ6: 'Can I match my invoices with bank statements?',
    faqA6: 'Yes, this is one of our most powerful features. You can upload your bank statements alongside your invoices. Our AI will automatically scan your transactions and match them with the corresponding invoices based on amounts, dates, and vendor names, significantly reducing manual bookkeeping.',
    faqQ7: 'What happens if a match is uncertain?',
    faqA7: 'The system provides a Match Score for each reconciliation. If the AI is unsure, it will flag the transaction for manual review. You can then confirm, reject, or manually link a transaction to a specific document with a single click.',
    faqQ8: 'What are the differences between the plans?',
    faqA8: 'While our Free Plan is perfect for individuals or small start-ups, our paid plans (starting at €3/month) offer higher monthly limits, advanced filtering, and priority support. Each tier is designed to scale with your business\'s volume of monthly invoices.',
    faqQ9: 'Can I cancel or change my plan at any time?',
    faqA9: 'Yes, you have full control over your subscription. You can upgrade to a higher tier as your business grows or downgrade/cancel at any time through your account settings.',
    faqQ10: 'Where is my data stored?',
    faqA10: 'Your data is securely stored on EU-based servers, ensuring compliance with strict data protection standards (GDPR). We use industry-standard encryption for both data at rest and in transit.',
    faqQ11: 'Is my financial data shared with third parties?',
    faqA11: 'No. We have a strict No-Sharing Policy. Your invoices, bank statements, and extracted data are used exclusively to provide you with the service and are never sold or shared with third-party advertisers.',
    faqQ12: 'How can I delete my data?',
    faqA12: 'You have full ownership of your data. You can delete individual invoices or your entire account at any time. Once deleted, all associated files and data are permanently removed from our active servers.',
  },
  de: {
    landingSeoTitle: "KontoMatch | KI Rechnungen verarbeiten & Bankabgleich",
    landingSeoDesc:
      "KontoMatch liest Ihre Rechnungen automatisch per OCR und gleicht sie mit dem Kontoauszug ab. KI-Buchhaltung für Freelancer und Kleinunternehmen. Kostenlos starten.",
    howSeoTitle: "KontoMatch | So funktioniert es",
    howSeoDesc: "Drei einfache Schritte: Ausgaben und Kontoauszüge hochladen, KI gleicht alles automatisch ab. So funktioniert KontoMatch.",
    securitySeoTitle: "KontoMatch | Sicherheit",
    securitySeoDesc: "KontoMatch speichert Ihre Daten auf EU-Servern mit branchenüblicher Verschlüsselung. DSGVO-konform. Ihre Rechnungen und Kontoauszüge werden niemals weitergegeben.",
    pricingSeoTitle: "KontoMatch | Preise",
    pricingSeoDesc: "KontoMatch bietet einen kostenlosen Plan und Bezahlpläne ab 3 €/Monat. KI-Rechnungsverarbeitung und Bankabgleich für Freelancer und Kleinunternehmen.",
    navHowItWorks: "So funktioniert es",
    navFeatures: "Funktionen",
    navPricing: "Preise",
    navSecurity: "Sicherheit",
    navAbout: "Über Uns",
    navSignIn: "Anmelden",
    navStartFree: "Kostenlos starten",

    heroTitle1: "Keine Wochenenden mehr",
    heroTitle2: "für Buchhaltung.",
    heroSub:
      "Sie laden hoch. Wir matchen alles. Ausgaben, Einnahmen, Kontoauszüge. abgeglichen in Sekunden.",
    heroBtn: "Kostenlos loslegen",
    heroNote: "Keine Kreditkarte erforderlich. Kostenlos starten.",
    heroTrust1: "Nur EU-Server",
    heroTrust2: "DSGVO-konform",
    heroTrust3: "Daten werden nie für Training verwendet",

    cardReceipt: "Beleg / Receipt",
    cardBank: "Kontoauszug",
    cardMatched: "Zugeordnet",
    cardAutoMatched: "Automatisch zugeordnet",
    cardMatchDesc: "Mediamarkt · 14.02.2025 · 349,00 €",
    cardTag1: "Steuerlich relevant",
    cardTag2: "Bürobedarf",
    cardTag3: "DATEV-bereit",

    proofTime: "Vom Upload bis zum Export",
    proofRate: "Auto-Match-Rate",
    proofSaved: "Gespart pro Monat",
    proofStart: "zum Starten",

    howTitle: "Drei Schritte. Kein Chaos.",
    howSub:
      "Keine Einarbeitung nötig. Wer eine Datei hochladen kann, kann auch KontoMatch nutzen.",
    how1Title: "Ausgaben hochladen",
    how1Desc:
      "Laden Sie Rechnungen, Belege und Abrechnungen in jedem Format hoch: PDF, JPG, PNG, HEIC. Dokumente aus den meisten Ländern werden nativ verarbeitet.",
    how2Title: "Kontoauszüge hochladen",
    how2Desc:
      "Importieren Sie Ihren monatlichen Auszug als PDF oder CSV-Export. Alle großen Banken werden unterstützt.",
    how3Title: "KI gleicht alles ab",
    how3Desc:
      "KontoMatch liest jedes Dokument, extrahiert Beträge und Daten und ordnet jeden Beleg der passenden Transaktion zu.",

    featTitle: "Alles, was Sie brauchen.",
    featSub:
      "Keine manuelle Eingabe. Keine Tabellen. Nur eine fertige Export-Datei.",
    feat1Title: "KI-Dokumentenerkennung",
    feat1Desc:
      "Liest gescannte Belege, E-Mail-Rechnungen und handschriftliche Notizen. Keine manuelle Eingabe.",
    feat2Title: "Intelligenter Bankabgleich",
    feat2Desc:
      "Jeder Beleg wird automatisch abgeglichen. Abweichungen und fehlende Belege werden sofort angezeigt.",
    feat3Title: "Automatische Kategorisierung",
    feat3Desc:
      "Ausgaben werden automatisch nach Kategorien sortiert. Reise, Software, Dienstleistungen und mehr.",
    feat4Title: "DATEV-fertiger Export",
    feat4Desc:
      "XLSX und exportkompatible CSV, die Ihr Steuerberater direkt importieren kann.",
    feat5Title: "Entwickelt für globale Teams",
    feat5Desc:
      "Mehrwährungsabgleich mit dem exakten Wechselkurs zum Ausgabenzeitpunkt. MwSt./GST und große Banken inklusive.",
    feat6Title: "Monatsübersicht",
    feat6Desc:
      "Klare Monatsübersicht über Einnahmen und Ausgaben über alle Abstimmungen hinweg.",

    secTitle: "Gesichert wie eine Schweizer Bank.",
    secSub: "Ihre Dokumente sind Ihre Sache. Niemand sonst.",
    sec1Title: "EU-Datenhosting",
    sec1Desc: "Alle Dokumente und Daten auf deutschen Servern gespeichert. KI-Verarbeitung mit DSGVO-konformen Schutzmaßnahmen gesichert.",
    sec2Title: "Bankgerechter Schutz",
    sec2Desc: "Ihre Dokumente werden mit denselben Verschlüsselungsstandards geschützt, denen Finanzinstitute vertrauen.",
    sec3Title: "Ihre Daten gehören Ihnen",
    sec3Desc: "Niemals verkauft. Niemals für unser KI-Training verwendet. Nur verarbeitet, um Ihre Ergebnisse zu liefern.",
    sec4Title: "Vollständige Löschung auf Anfrage",
    sec4Desc: "Exportieren oder löschen Sie alle Ihre Daten jederzeit dauerhaft.",

    prTitle: "Preise",
    prH2: "Einfaches, ehrliches Pricing",
    prSub: "Kostenlos starten, nur zahlen wenn Sie es brauchen",

    prFreeTitle: "Kostenlos",
    prFreeDesc: "Für alle, die es richtig ausprobieren wollen. Kein Zeitlimit, kein Haken.",
    prFreePeriod: "für immer",
    prFreeF1: "Bis zu 20 Dokumente",
    prFreeF2: "KI-Abgleich & Kategorisierung",
    prFreeF3: "XLSX-Export",
    prFreeF4: "DATEV-Export",
    prFreeF5: "Bevorzugte Verarbeitung",
    prFreeF6: "Mehrmonatige Historie",
    prFreeF7: "",
    prFreeBtn: "Kostenlos starten",

    prPayTitle: "Pay as you go",
    prPayDesc: "Für Freelancer, die vierteljährlich abstimmen. Nur zahlen bei Nutzung.",
    prPayPeriod: "pro Matching-Lauf",
    prPayF1: "Bis zu 50 Dokumente",
    prPayF2: "KI-Abgleich & Kategorisierung",
    prPayF3: "XLSX + DATEV Export",
    prPayF4: "Markierung fehlender Dokumente",
    prPayF5: "Vollständiges Audit-Trail",
    prPayF6: "Bevorzugte Verarbeitung",
    prPayF7: "10 Jahre Datenaufbewahrung",
    prPayBtn: "Loslegen",

    prProBadge: "Am Beliebtesten",
    prStarTitle: "Starter",
    prStarDesc: "Für Gründer und Freelancer mit monatlicher Buchhaltung. Planbare Kosten.",
    prStarPeriod: "/Monat",
    prStarF1: "Bis zu 100 Dokumente pro Monat",
    prStarF2: "KI-Abgleich & Kategorisierung",
    prStarF3: "XLSX + DATEV Export",
    prStarF4: "Markierung fehlender Dokumente",
    prStarF5: "Vollständiges Audit-Trail",
    prStarF6: "Bevorzugte Verarbeitung",
    prStarF7: "10 Jahre Datenaufbewahrung",
    prStarBtn: "Loslegen",

    prProTitle: "Pro",
    prProDesc: "Für aktive Unternehmen oder wöchentliche Abstimmung.",
    prProF1: "Bis zu 500 Dokumente/Monat",
    prProF2: "KI-Abgleich & Kategorisierung",
    prProF3: "XLSX + DATEV Export",
    prProF4: "Vollständiges Audit-Trail",
    prProF5: "Bevorzugte Verarbeitung",
    prProF6: "10 Jahre Datenaufbewahrung",
    prProF7: "Früher Zugang zu neuen Features",

    ctaTitle1: "Keine Wochenenden mehr",
    ctaTitle2: "für die Buchhaltung opfern.",
    ctaSub:
      "Schließen Sie sich Gründern und Freelancern weltweit an, die diesen Monat bereits 10+ Stunden gespart haben.",
    ctaBtn: "Kostenlos starten",
    ctaT1: "Keine Kreditkarte erforderlich",
    ctaT2: "Kostenlos starten",
    ctaT3: "Live in Minuten",

    footBrand: "Von Praktikern. Für Praktiker.",
    footProduct: "Produkt",
    footLegal: "Rechtliches",
    footLang: "Sprache",
    footTerms: "AGB",
    footPrivacy: "Datenschutz",
    footImprint: "Impressum",
    footGDPR: "DSGVO",

    heroAnimBankStatement: "Kontoauszug",
    heroAnim1Transaction: "1 Transaktion",
    heroAnim2Transactions: "2 Transaktionen",
    heroAnim3Transactions: "3 Transaktionen",
    heroAnim4Transactions: "4 Transaktionen",
    heroAnimExpensesRevenues: "Ausgaben & Einnahmen",
    heroAnim1Receipt: "1 Beleg",
    heroAnim2Receipts: "2 Belege",
    heroAnim3Receipts: "3 Belege",
    heroAnim4Receipts: "4 Belege",
    heroAnimDropCsv: "CSV-Dateien hier ablegen",
    heroAnimDropReceipts: "Belege hier ablegen",
    heroAnimMatchedAuto: "3 Transaktionen automatisch zugeordnet",
    heroAnimNeedsReview: "1 muss überprüft werden",
    stepAnimDropOrClick: "Ablegen oder klicken",
    stepAnimRecentDocs: "AKTUELLE DOKUMENTE",
    stepAnimNoDocs: "Noch keine Dokumente",
    stepAnimUploadExpenses: "Ausgaben hochladen",
    stepAnimUploadRevenue: "Einnahmen hochladen",
    stepAnimStatementTitle: "Kontoauszug · Jan 2025",
    stepAnimDate: "Datum",
    stepAnimPurpose: "Verwendungszweck",
    stepAnimAmount: "Betrag",
    stepAnim4Transactions: "4 Transaktionen",
    stepAnim4Receipts: "4 Belege",

    stepAnimExpFile1: "strom_okt.csv",
    stepAnimExpAmt1: "1.240 €",
    stepAnimExpFile2: "miete_rechnung.pdf",
    stepAnimExpAmt2: "3.500 €",
    stepAnimExpFile3: "material_q3.xlsx",
    stepAnimExpAmt3: "870 €",
    stepAnimRevFile1: "kontoauszug_jan.pdf",
    stepAnimRevAmt1: "2.400 €",
    stepAnimRevFile2: "umsatz_q3.csv",
    stepAnimRevAmt2: "18.200 €",
    stepAnimRevFile3: "einnahmen_okt.xlsx",
    stepAnimRevAmt3: "9.750 €",
    stepAnimExpIcon1: "strom.csv",
    stepAnimExpIcon2: "miete.pdf",
    stepAnimExpIcon3: "material.xlsx",
    stepAnimRevIcon1: "auszug_jan.pdf",
    stepAnimRevIcon2: "umsatz_q3.csv",
    stepAnimRevIcon3: "einnahmen.xlsx",
    faqPageTitle: 'KontoMatch | FAQ',
    faqPageDescription: 'Antworten auf die häufigsten Fragen zur Rechnungsverarbeitung, Kontoabstimmung, OCR-Genauigkeit und Datensicherheit bei KontoMatch.',
    faqH2: 'Häufig gestellte Fragen',
    faqSub: 'Alles, was Sie über KontoMatch wissen müssen.',
    faqCatGeneral: 'Allgemein',
    faqCatOCR: 'OCR & Genauigkeit',
    faqCatMatch: 'Abgleich & Abstimmung',
    faqCatSec: 'Sicherheit & Datenschutz',
    faqQ1: 'Was genau macht KontoMatch?',
    faqA1: 'KontoMatch ist eine KI-gestützte Plattform, die entwickelt wurde, um Ihr Ausgabenmanagement zu automatisieren. Sie können Ihre Rechnungen (im PDF- oder Bildformat) hochladen, und unser System extrahiert automatisch wichtige Details wie Anbieter, Datum, Betrag und Steuern. Es kategorisiert diese Ausgaben auch und ermöglicht es Ihnen, sie als organisierte Excel-Berichte zu exportieren.',
    faqQ2: 'Benötige ich eine Kreditkarte, um loszulegen?',
    faqA2: 'Nein. Sie können sich anmelden und unseren kostenlosen Plan sofort nutzen, ohne Kreditkarteninformationen anzugeben. Wir glauben, dass Sie den Wert unserer Optical Character Recognition (OCR)-Technologie erleben sollten, bevor Sie sich für ein Upgrade entscheiden.',
    faqQ3: 'Welche Dateiformate werden für Uploads unterstützt?',
    faqA3: 'Wir unterstützen gängige digitale Formate wie PDF, JPEG und PNG. Ob Sie einen digitalen Beleg oder ein Foto einer physischen Rechnung haben, unsere KI kann dies verarbeiten.',
    faqQ4: 'Wie genau ist die OCR-Technologie?',
    faqA4: 'Unsere proprietäre KI-gestützte Optical Character Recognition (OCR)-Engine ist für hohe Genauigkeit optimiert und erreicht über 90 % Genauigkeit bei der Datenextraktion. In internen Benchmarks übertrifft sie konsequent generische Lösungen wie Google Document AI, Gemini und ChatGPT, insbesondere bei lokalisierten Rechnungsformaten.',
    faqQ5: 'Unterstützt die Plattform mehrere Rechnungen in einer Datei?',
    faqA5: 'Ja! Unser System verfügt über eine Mehrfachrechnungserkennung, d. h. es kann verschiedene Rechnungen identifizieren und trennen, selbst wenn sie in demselben Dokument oder Paket hochgeladen wurden.',
    faqQ6: 'Kann ich meine Rechnungen mit Bankauszügen abgleichen?',
    faqA6: 'Ja, das ist eine unserer leistungsstärksten Funktionen. Sie können Ihre Bankbelege zusammen mit Ihren Rechnungen hochladen. Unsere KI scannt automatisch Ihre Transaktionen und gleicht sie basierend auf Beträgen, Daten und Anbieternamen mit den entsprechenden Rechnungen ab, was die manuelle Buchführung erheblich reduziert.',
    faqQ7: 'Was passiert, wenn ein Abgleich unsicher ist?',
    faqA7: 'Das System liefert für jede Abstimmung einen Match Score. Wenn die KI unsicher ist, wird die Transaktion für eine manuelle Überprüfung markiert. Sie können dann eine Transaktion bestätigen, ablehnen oder manuell mit einem Klick mit einem bestimmten Dokument verknüpfen.',
    faqQ8: 'Was sind die Unterschiede zwischen den Tarifen?',
    faqA8: 'Während unser kostenloser Plan perfekt für Einzelpersonen oder kleine Startups ist, bieten unsere kostenpflichtigen Pläne (ab 3 €/Monat) höhere monatliche Limits, erweitertes Filtern und Priority-Support. Jede Stufe ist so konzipiert, dass sie mit dem monatlichen Rechnungsvolumen Ihres Unternehmens skaliert.',
    faqQ9: 'Kann ich meinen Tarif jederzeit kündigen oder ändern?',
    faqA9: 'Ja, Sie haben die volle Kontrolle über Ihr Abonnement. Sie können auf eine höhere Stufe upgraden, wenn Ihr Unternehmen wächst, oder jederzeit in Ihren Kontoeinstellungen ein Downgrade vornehmen oder kündigen.',
    faqQ10: 'Wo werden meine Daten gespeichert?',
    faqA10: 'Ihre Daten werden sicher auf EU-basierten Servern gespeichert, um die Einhaltung strenger Datenschutzstandards (DSGVO) zu gewährleisten. Wir verwenden branchenübliche Verschlüsselung für Daten sowohl im Ruhezustand als auch bei der Übertragung.',
    faqQ11: 'Werden meine Finanzdaten an Dritte weitergegeben?',
    faqA11: 'Nein. Wir haben eine strikte Keine-Weitergabe-Politik. Ihre Rechnungen, Bankbelege und extrahierten Daten werden ausschließlich zur Bereitstellung des Dienstes verwendet und niemals an Drittwerber verkauft oder an diese weitergegeben.',
    faqQ12: 'Wie kann ich meine Daten löschen?',
    faqA12: 'Sie haben das volle Eigentum an Ihren Daten. Sie können einzelne Rechnungen oder Ihr gesamtes Konto jederzeit löschen. Nach dem Löschen werden alle zugehörigen Dateien und Daten dauerhaft von unseren aktiven Servern entfernt.',
  },
  tr: {
    landingSeoTitle: "KontoMatch | Yapay Zeka Muhasebe ve Uzlaştırma",
    landingSeoDesc:
      "Giderleri ve banka ekstrelerini yükleyin, ardından KontoMatch her şeyi saniyeler içinde eşleştirip uzlaştırsın.",
    navHowItWorks: "Nasıl Çalışır",
    navFeatures: "Özellikler",
    navPricing: "Fiyatlandırma",
    navSecurity: "Güvenlik",
    navAbout: "Hakkımızda",
    navSignIn: "Giriş Yap",
    navStartFree: "Ücretsiz Başla",

    heroTitle1: "Hafta sonlarını",
    heroTitle2: "muhasebeye harcamayın.",
    heroSub:
      "Siz yükleyin. Biz eşleştirelim. Giderler, gelirler, banka ekstreleri. saniyeler içinde eşleştirilir.",
    heroBtn: "Ücretsiz başlayın",
    heroNote: "Kredi kartı gerekmez. Başlamak ücretsiz.",
    heroTrust1: "Yalnızca AB sunucuları",
    heroTrust2: "GDPR uyumlu",
    heroTrust3: "Veriler eğitim için asla kullanılmaz",

    cardReceipt: "Fiş / Fatura",
    cardBank: "Banka Ekstresi",
    cardMatched: "Eşleşti",
    cardAutoMatched: "Otomatik Eşleşti",
    cardMatchDesc: "Mediamarkt · 14.02.2025 · 349,00 €",
    cardTag1: "Vergiye Tabi",
    cardTag2: "Ofis Malzemeleri",
    cardTag3: "DATEV Uyumlu",

    proofTime: "Yüklemeden Dışa Aktarıma",
    proofRate: "Otomatik Eşleşme Oranı",
    proofSaved: "Aylık Tasarruf",
    proofStart: "başlangıç için",

    howTitle: "Üç adım. Sıfır karmaşa.",
    howSub:
      "Eğitim gerekmez. Sürükleyip bırakmayı biliyorsanız, KontoMatch'yu kullanabilirsiniz.",
    how1Title: "Giderlerinizi yükleyin",
    how1Desc:
      "Faturaları, fişleri ve belgeleri her formatta yükleyin: PDF, JPG, PNG, HEIC. Çoğu ülkeden belgeler yerel olarak işlenir.",
    how2Title: "Banka ekstrenizi yükleyin",
    how2Desc:
      "Aylık hesap ekstrenizi PDF veya CSV olarak içe aktarın. Tüm büyük bankalar desteklenir.",
    how3Title: "Yapay zeka her şeyi eşleştirir",
    how3Desc:
      "KontoMatch her belgeyi okur, tutarları ve tarihleri çıkarır ve doğru işleme aktarır.",

    featTitle: "İhtiyacınız olan her şey.",
    featSub:
      "Manuel veri girişi yok. Excel tabloları yok. Sadece eksiksiz, dışa aktarılmaya hazır bir dosya.",
    feat1Title: "Yapay zeka belge okuma",
    feat1Desc:
      "Taranmış fişleri, e-posta faturalarını ve el yazısı notları okur. Manuel giriş gerekmez.",
    feat2Title: "Akıllı eşleştirme",
    feat2Desc:
      "Her belge otomatik eşleştirilir. Tutarsızlıklar ve eksik fişler anında görünür.",
    feat3Title: "Otomatik sınıflandırma",
    feat3Desc:
      "Giderler seyahat, yazılım, hizmetler ve daha fazlası gibi kategorilere otomatik olarak ayrılır.",
    feat4Title: "DATEV Uyumlu Dışa Aktarım",
    feat4Desc:
      "Muhasebecinizin doğrudan içeri aktarabileceği formatta XLSX ve CSV.",
    feat5Title: "Küresel Ekipler İçin Tasarlandı",
    feat5Desc:
      "Harcama anındaki tam döviz kuru ile çoklu para birimi eşleştirmesi. KDV/GST ve büyük bankalar dahil.",
    feat6Title: "Aylık Özet",
    feat6Desc:
      "Tüm uzlaştırmalar genelinde temiz, ay bazında gelir-gider görünümü.",

    secTitle: "İsviçre bankası gibi güvenli.",
    secSub: "Belgeleriniz sadece sizi ilgilendirir. Başkasını değil.",
    sec1Title: "AB veri barındırma",
    sec1Desc: "Tüm belgeler ve veriler Alman sunucularında saklanır. Yapay zeka işleme GDPR uyumlu güvencelerle korunur.",
    sec2Title: "Banka düzeyinde koruma",
    sec2Desc: "Belgeleriniz finans kurumlarının güvendiği şifreleme standartlarıyla korunur.",
    sec3Title: "Verileriniz sizin kalır",
    sec3Desc: "Asla satılmaz. AI eğitimimiz için asla kullanılmaz. Sadece sonuçlarınızı üretmek için işlenir.",
    sec4Title: "Talep üzerine tam silme",
    sec4Desc: "İstediğiniz zaman tüm verilerinizi dışa aktarın veya kalıcı olarak silin.",

    prTitle: "Fiyatlandırma",
    prH2: "Basit ve Dürüst Fiyatlandırma",
    prSub: "Ücretsiz başlayın, yalnızca ihtiyacınız olduğunda büyütün",

    prFreeTitle: "Ücretsiz",
    prFreeDesc: "Doğru şekilde denemek isteyen herkes için. Süre sınırı yok, gizli şart yok.",
    prFreePeriod: "ömür boyu",
    prFreeF1: "En fazla 20 belge",
    prFreeF2: "AI eşleştirme ve sınıflandırma",
    prFreeF3: "XLSX dışa aktarımı",
    prFreeF4: "DATEV dışa aktarımı",
    prFreeF5: "Öncelikli işleme",
    prFreeF6: "Çok aylık geçmiş",
    prFreeF7: "",
    prFreeBtn: "Ücretsiz Başla",

    prPayTitle: "Kullandıkça öde",
    prPayDesc: "Üç aylık uzlaştırma yapan freelancer'lar için. Sadece kullandığınızda ödeyin.",
    prPayPeriod: "eşleştirme başına",
    prPayF1: "En fazla 50 belge",
    prPayF2: "AI eşleştirme ve sınıflandırma",
    prPayF3: "XLSX + DATEV dışa aktarımı",
    prPayF4: "Eksik belge bildirimi",
    prPayF5: "Tam denetim izi",
    prPayF6: "Öncelikli işleme",
    prPayF7: "10 yıl veri saklama",
    prPayBtn: "Hemen Başla",

    prProBadge: "En Popüler",
    prStarTitle: "Starter",
    prStarDesc: "Aylık muhasebe yapan kurucular ve freelancer'lar için. Öngörülebilir maliyet.",
    prStarPeriod: "/ay",
    prStarF1: "Ayda 100 belgeye kadar",
    prStarF2: "AI eşleştirme ve sınıflandırma",
    prStarF3: "XLSX + DATEV dışa aktarımı",
    prStarF4: "Eksik belge bildirimi",
    prStarF5: "Tam denetim izi",
    prStarF6: "Öncelikli işleme",
    prStarF7: "10 yıl veri saklama",
    prStarBtn: "Hemen Başla",

    prProTitle: "Pro",
    prProDesc: "Aktif işletmeler veya haftalık uzlaştırma yapan herkes için.",
    prProF1: "Ayda 500 belgeye kadar",
    prProF2: "AI eşleştirme ve sınıflandırma",
    prProF3: "XLSX + DATEV dışa aktarımı",
    prProF4: "Tam denetim izi",
    prProF5: "Öncelikli işleme",
    prProF6: "10 yıl veri saklama",
    prProF7: "Yeni özelliklere erken erişim",

    ctaTitle1: "Hafta sonlarınızı",
    ctaTitle2: "muhasebeye ayırmayın.",
    ctaSub:
      "Bu ay zaten 10+ saat kazanan dünya çapındaki kuruculara ve freelancer'lara katılın.",
    ctaBtn: "Ücretsiz Başla",
    ctaT1: "Kredi Kartı Gerekmez",
    ctaT2: "Başlamak ücretsiz",
    ctaT3: "Dakikalar içinde canlı",

    footBrand: "Operatörler tarafından. Operatörler için.",
    footProduct: "Ürün",
    footLegal: "Yasal Bilgiler",
    footLang: "Dil Seçenekleri",
    footTerms: "Hizmet Şartları",
    footPrivacy: "Gizlilik Politikası",
    footImprint: "Künye Bilgisi",
    footGDPR: "GDPR",

    heroAnimBankStatement: "Banka Ekstresi",
    heroAnim1Transaction: "1 İşlem",
    heroAnim2Transactions: "2 İşlem",
    heroAnim3Transactions: "3 İşlem",
    heroAnim4Transactions: "4 İşlem",
    heroAnimExpensesRevenues: "Giderler & Gelirler",
    heroAnim1Receipt: "1 Fiş",
    heroAnim2Receipts: "2 Fiş",
    heroAnim3Receipts: "3 Fiş",
    heroAnim4Receipts: "4 Fiş",
    heroAnimDropCsv: "CSV dosyalarını buraya bırakın",
    heroAnimDropReceipts: "Fişleri buraya bırakın",
    heroAnimMatchedAuto: "3 işlem otomatik olarak eşleştirildi",
    heroAnimNeedsReview: "1 tanesi inceleme gerektiriyor",
    stepAnimDropOrClick: "Bırakın veya tıklayın",
    stepAnimRecentDocs: "SON BELGELER",
    stepAnimNoDocs: "Henüz belge yok",
    stepAnimUploadExpenses: "Giderleri Yükle",
    stepAnimUploadRevenue: "Gelirleri Yükle",
    stepAnimStatementTitle: "Ekstre · Oca 2025",
    stepAnimDate: "Tarih",
    stepAnimPurpose: "Açıklama",
    stepAnimAmount: "Tutar",
    stepAnim4Transactions: "4 İşlem",
    stepAnim4Receipts: "4 Fiş",

    stepAnimExpFile1: "faturalar_ekm.csv",
    stepAnimExpAmt1: "1.240 ₺",
    stepAnimExpFile2: "kira_faturasi.pdf",
    stepAnimExpAmt2: "3.500 ₺",
    stepAnimExpFile3: "malzemeler_c3.xlsx",
    stepAnimExpAmt3: "870 ₺",
    stepAnimRevFile1: "hesapozeti_oca.pdf",
    stepAnimRevAmt1: "2.400 ₺",
    stepAnimRevFile2: "satislar_c3.csv",
    stepAnimRevAmt2: "18.200 ₺",
    stepAnimRevFile3: "gelir_ekm.xlsx",
    stepAnimRevAmt3: "9.750 ₺",
    stepAnimExpIcon1: "faturalar.csv",
    stepAnimExpIcon2: "kira.pdf",
    stepAnimExpIcon3: "malzemeler.xlsx",
    stepAnimRevIcon1: "ozet_oca.pdf",
    stepAnimRevIcon2: "satislar_c3.csv",
    stepAnimRevIcon3: "gelir.xlsx",
    faqH2: 'Sıkça Sorulan Sorular',
    faqSub: 'KontoMatch hakkında merak ettiğiniz her şey.',
    faqCatGeneral: 'Genel',
    faqCatOCR: 'OCR & Doğruluk',
    faqCatMatch: 'Uzlaştırma & Eşleştirme',
    faqCatSec: 'Güvenlik & Gizlilik',
    faqQ1: 'KontoMatch tam olarak ne yapar?',
    faqA1: 'KontoMatch, harcama yönetiminizi otomatikleştirmek için tasarlanmış yapay zekâ destekli bir platformdur. Faturalarınızı (PDF veya görsel formatında) yükleyebilirsiniz ve sistemimiz satıcı, tarih, tutar ve vergi gibi temel detayları otomatik olarak çıkarır. Ayrıca bu harcamaları kategorize eder ve düzenli Excel raporları olarak dışa aktarmanıza olanak tanır.',
    faqQ2: 'Başlamak için kredi kartına ihtiyacım var mı?',
    faqA2: 'Hayır. Herhangi bir kredi kartı bilgisi vermeden hemen kaydolabilir ve Ücretsiz Planımızı kullanmaya başlayabilirsiniz. Yükseltme yapmaya karar vermeden önce Optical Character Recognition (OCR - Optik Karakter Tanıma) teknolojimizin değerini deneyimlemeniz gerektiğine inanıyoruz.',
    faqQ3: 'Yüklemeler için hangi dosya formatları destekleniyor?',
    faqA3: 'PDF, JPEG ve PNG dahil olmak üzere yaygın dijital formatları destekliyoruz. İster dijital bir makbuzunuz ister fiziksel bir faturanın fotoğrafı olsun, yapay zekâmız bunu işleyebilir.',
    faqQ4: 'OCR teknolojisi ne kadar doğru?',
    faqA4: 'Tescilli yapay zekâ destekli Optical Character Recognition (OCR - Optik Karakter Tanıma) motorumuz, veri çıkarmada %90\'ın üzerinde doğruluk oranına ulaşarak yüksek hassasiyet için optimize edilmiştir. Dahili testlerde, özellikle yerelleştirilmiş fatura formatları için Google Document AI, Gemini ve ChatGPT gibi genel çözümlerden sürekli olarak daha iyi performans göstermektedir.',
    faqQ5: 'Platform tek bir dosyada birden fazla faturayı destekliyor mu?',
    faqA5: 'Evet! Sistemimiz Çoklu Fatura Algılama özelliğine sahiptir, yani aynı belge veya paket içinde yüklenmiş olsalar bile farklı faturaları tanımlayabilir ve ayırabilir.',
    faqQ6: 'Faturalarımı banka ekstreleri ile eşleştirebilir miyim?',
    faqA6: 'Evet, bu en güçlü özelliklerimizden biridir. Banka ekstrelerinizi faturalarınızla birlikte yükleyebilirsiniz. Yapay zekâmız işlemlerinizi otomatik olarak tarayacak ve tutarlar, tarihler ve satıcı adlarına göre ilgili faturalarla eşleştirerek manuel defter tutma işlemlerini önemli ölçüde azaltacaktır.',
    faqQ7: 'Eşleşme belirsizse ne olur?',
    faqA7: 'Sistem her uzlaştırma için bir Eşleşme Puanı sağlar. Yapay zekâ emin değilse, işlemi manuel inceleme için işaretler. Daha sonra tek bir tıklamayla bir işlemi onaylayabilir, reddedebilir veya manuel olarak belirli bir belgeye bağlayabilirsiniz.',
    faqQ8: 'Planlar arasındaki farklar nelerdir?',
    faqA8: 'Ücretsiz Planımız bireyler veya küçük girişimler için mükemmel olsa da, (aylık 3 €\'dan başlayan) ücretli planlarımız daha yüksek aylık limitler, gelişmiş filtreleme ve öncelikli destek sunar. Her seviye, işletmenizin aylık fatura hacmine göre ölçeklenecek şekilde tasarlanmıştır.',
    faqQ9: 'Planımı istediğim zaman iptal edebilir veya değiştirebilir miyim?',
    faqA9: 'Evet, aboneliğiniz üzerinde tam kontrole sahipsiniz. İşletmeniz büyüdükçe daha yüksek bir seviyeye geçebilir veya istediğiniz zaman hesap ayarlarınızdan seviye düşürebilir/iptal edebilirsiniz.',
    faqQ10: 'Verilerim nerede saklanıyor?',
    faqA10: 'Verileriniz, katı veri koruma standartlarına (GDPR) uyumu sağlayan AB tabanlı sunucularda güvenli bir şekilde saklanır. Hem beklemedeki hem de aktarımdaki veriler için endüstri standardında şifreleme kullanıyoruz.',
    faqQ11: 'Finansal verilerim üçüncü taraflarla paylaşılıyor mu?',
    faqA11: 'Hayır. Katı bir Paylaşmama Politikamız var. Faturalarınız, banka ekstreleriniz ve çıkarılan verileriniz size yalnızca hizmet sunmak için kullanılır ve asla üçüncü taraf reklamverenlerle satılmaz veya paylaşılmaz.',
    faqQ12: 'Verilerimi nasıl silebilirim?',
    faqA12: 'Verilerinizin tam mülkiyetine sahipsiniz. İstediğiniz zaman bireysel faturaları veya tüm hesabınızı silebilirsiniz. Silindikten sonra, tüm ilişkili dosyalar ve veriler aktif sunucularımızdan kalıcı olarak kaldırılır.',
  },
};
